import React, { RefObject } from 'react';
import { MomentInput } from 'moment';

import { localTime } from '@helpers';

import { AlarmEvent, TriggerHidePopup, TriggerShowPopup } from '@interfaces/timeline';

import { LegendRules } from '@components/machines/components/timeline/calculations/index';
import { Popup } from '@components/machines/components/timeline';
import { TIMELINE_LINE_CONFIG, TIMELINE_UNDERLINE_TEXT_CONFIG } from '@components/machines/components/timeline/constants';
import { getTimelineFontStyles } from '@components/machines/components/timeline/helpers';
import { ColorFunction } from '@styles/colors/types';

export default (props: {
  C: ColorFunction;
  triggerShowPopup: TriggerShowPopup;
  triggerHidePopup: TriggerHidePopup;
  alarmEvents: AlarmEvent[];
  blockWidth: number;
  startTime: MomentInput;
  rules: LegendRules;
  timelineRef: RefObject<HTMLDivElement>;
}) => {
  const { C, alarmEvents, blockWidth, startTime, rules, triggerShowPopup, triggerHidePopup, timelineRef } = props;

  const { fontStylesWeb } = getTimelineFontStyles();

  return (
    <div>
      <div
        style={{
          display: 'flex',
          height: TIMELINE_LINE_CONFIG.height,
          width: blockWidth,
          borderRadius: TIMELINE_LINE_CONFIG.borderRadius,
          backgroundColor: C(TIMELINE_LINE_CONFIG.backgroundColor),
          flexDirection: 'row',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        {alarmEvents.map((i) => {
          const elementSeconds = localTime(i.startedOn).diff(localTime(startTime), 's');

          return (
            <div
              key={`${i.startedOn}-${i.endedOn}-alarm-label-event`}
              style={{
                left: rules.secondWidth * elementSeconds,
                width: i.durationInSeconds * rules.secondWidth,
                minWidth: 1,
                height: '100%',
                backgroundColor: C('Label/Light/Error'),
                overflow: 'hidden',
                position: 'absolute',
              }}
            ></div>
          );
        })}
      </div>
      <div
        style={{
          display: 'flex',
          height: 20,
          width: blockWidth,
          borderRadius: 3,
          flexDirection: 'row',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        {alarmEvents.map((i, index) => {
          const elementSeconds = localTime(i.startedOn).diff(localTime(startTime), 's');
          const nextElement = alarmEvents[index + 1];
          let width = i.durationInSeconds;
          if (nextElement) {
            const elementSecondsNext = localTime(nextElement.startedOn).diff(localTime(startTime), 's');
            width = elementSecondsNext - elementSeconds;
          }

          const displayWidth = rules.secondWidth * width - 5;
          const showElement = displayWidth > 5;
          return (
            <div
              key={`${i.startedOn}-${i.endedOn}-alarm-event`}
              style={{
                position: 'absolute',
                left: rules.secondWidth * elementSeconds,
                minWidth: 1,
                height: '100%',
                overflow: 'hidden',
                display: 'flex',
                background: C('Background/Light/Field'),
                opacity: showElement ? 1 : 0,
                ...(nextElement ? { width: displayWidth } : {}),
              }}
              onMouseOver={(event) => {
                const timelineRect = timelineRef?.current?.getBoundingClientRect();
                if (timelineRect) {
                  const el: any = event.target;
                  const width = i.durationInSeconds * rules.secondWidth;
                  const rect = el.getBoundingClientRect();
                  const position = {
                    top: rect.top - timelineRect.top - 10,
                    left: rect.left - timelineRect.left,
                  };

                  triggerShowPopup(
                    {
                      show: true,
                      item: i,
                      width,
                      position,
                    },
                    'alarm'
                  );
                }
              }}
              onMouseOut={() => {
                triggerHidePopup('alarm');
              }}
            >
              <>
                <div
                  style={{
                    ...fontStylesWeb,
                    color: C(TIMELINE_UNDERLINE_TEXT_CONFIG.color),
                    whiteSpace: 'nowrap',
                    userSelect: 'none',
                  }}
                >
                  {i.errorText}
                </div>
                <div style={{ height: '100%', width: 5, background: 'Background/Light/System' }} />
              </>
            </div>
          );
        })}
      </div>
    </div>
  );
};
